// **React Imports
import React, { memo, useMemo, useState } from 'react'

// **MUI Imports
import { Box, Typography } from '@mui/material'

// **Component Imports
import IconifyIcon from '../icon'

const formatTimeAgo = (timestamp) => {
  if (!timestamp) return ''
  const now = new Date()
  const diff = now - new Date(timestamp)
  if (isNaN(diff)) return ''
  const minutes = Math.floor(diff / 60000)
  const hours = Math.floor(diff / 3600000)
  const days = Math.floor(diff / 86400000)

  if (minutes < 1) return 'Just now'
  if (minutes < 60) return `${minutes}m ago`
  if (hours < 24) return `${hours}h ago`
  return `${days}d ago`
}

const ChatHistory = ({ history, onSelectChat }) => {
  const [showAll, setShowAll] = useState(false)

  const displayedChats = useMemo(() => {
    return showAll ? history : history.slice(0, 3)
  }, [history, showAll])

  if (!history.length) return null

  return (
    <Box className="chatbot-history">
      <Box className="chatbot-history__header">
        <IconifyIcon icon="mdi:history" fontSize="16px" />
        <Typography variant="caption" className="chatbot-history__title">
          Recent Conversations
        </Typography>
      </Box>
      <Box className="chatbot-history__list">
        {displayedChats.map((chat) => (
          <Box
            key={chat.threadId || chat.id}
            className="chatbot-history__item"
            onClick={() => onSelectChat(chat)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && onSelectChat(chat)}
          >
            <IconifyIcon
              icon="mdi:message-outline"
              className="chatbot-history__item-icon"
              fontSize="16px"
            />
            <Box className="chatbot-history__item-content">
              <Typography
                variant="body2"
                className="chatbot-history__item-title"
              >
                {chat.title}
              </Typography>
              <Typography
                variant="caption"
                className="chatbot-history__item-preview"
              >
                {chat.preview || 'Click to view conversation'}
              </Typography>
            </Box>
            <Typography
              variant="caption"
              className="chatbot-history__item-time"
            >
              {formatTimeAgo(chat.createdTs)}
            </Typography>
          </Box>
        ))}
      </Box>
      {history.length > 3 && !showAll && (
        <Typography
          variant="caption"
          className="chatbot-history__see-more"
          onClick={() => setShowAll(true)}
          role="button"
          tabIndex={0}
          onKeyDown={(e) => e.key === 'Enter' && setShowAll(true)}
        >
          See more
        </Typography>
      )}
    </Box>
  )
}

export default memo(ChatHistory)
